import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: true
    },
    allMessageList: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        title: undefined,
        code: '',
        content: ''
      },
      loading: false,
      btnShow: 2
    };
  },
  computed: {
    rules() {
      return {
        title: [{
          required: true,
          message: this.$t('请选择') + this.$t('短信名称'),
          trigger: 'change'
        }],
        code: [{
          required: true,
          message: this.$t('请输入') + this.$t('code值'),
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: this.$t('请输入') + this.$t('短信内容'),
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    item: {
      handler(val) {
        this.form = {
          title: undefined,
          content: '',
          code: ''
        };
        if (val && val.id) {
          //设置表单回显数据
          this.setFormData(val);
          this.$nextTick(() => {
            var _this$$refs$ruleForm;
            (_this$$refs$ruleForm = this.$refs.ruleForm) === null || _this$$refs$ruleForm === void 0 || _this$$refs$ruleForm.validate();
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    messageChange(value) {
      let selectItem = this.allMessageList.filter(item => item.name === value);
      this.form.content = selectItem !== null && selectItem !== void 0 && selectItem[0] ? selectItem[0].content : '';
      this.form.code = selectItem !== null && selectItem !== void 0 && selectItem[0] ? selectItem[0].code : '';
      this.$refs.ruleForm.validateField('content');
      this.$refs.ruleForm.validateField('code');
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    setFormData(val) {
      this.form = {
        title: val.title || undefined,
        code: val.code,
        content: val.content
      };
    }
  }
};